<!-- <p>aumye-emergency-respond works!</p> -->
<div class="aumye-emergency-respond-container">
  <div class="emergency-respond-header">Emergency Respond</div>
</div>
<!-- RequestDialog Message -->
<ng-template #RespondDialog>
  <h2 matDialogTitle>Responding Advanced SoS</h2>
  <mat-dialog-content>
    <div style="display: flex; flex-direction: column; align-items: center">
      <b><i>Fetching your location!</i></b>
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>

<!-- InititateDialog Message -->
<ng-template #FetchingDataDialog>
  <h2 matDialogTitle>Advanced SoS</h2>
  <mat-dialog-content>
    <div style="display: flex; flex-direction: column; align-items: center">
      <b><i>Fetching Data</i></b>
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #FetchingDataFailedDialog>
  <h2 matDialogTitle>Advanced SoS</h2>
  <mat-dialog-content>
    <div style="display: flex; flex-direction: column; align-items: center">
      <b><i>Fetching Data Failed</i></b>
    </div>
  </mat-dialog-content>
</ng-template>

<!-- UserAlreadyRespondedDialog Message -->
<ng-template #UserAlreadyRespondedDialog>
  <h2 matDialogTitle>Responding Advanced SoS</h2>
  <mat-dialog-content>
    <div style="display: flex; flex-direction: column; align-items: center">
      <b>You have already reponded!</b>
      <br />
      <button
        style="color: white; background-color: #204f84"
        (click)="onNavigateMaps()"
        mat-raised-button
      >
        Nagivate to google maps!
      </button>
    </div>
  </mat-dialog-content>
</ng-template>
